module.exports = __webpack_public_path__ + "img/cover-spacegunners.093fad81.png";